import { ColorType } from './type'

export const darkColor: ColorType = {
  bgGray: 'rgba(20,21,26,1)',
  bg: 'rgba(23,26,30,1)',
  bgLightGray: 'rgba(35,37,45,1)',
  bgPopup: 'rgba(172,172,172,0.100)',
  primary10: 'rgba(69, 97, 23, 1)',
  primary20: 'rgba(142,205,30,1)',
  primary30: 'rgba(160,238,9,1)',
  primary40: 'rgba(217,255,142,1)',
  primary50: 'rgba(64,84,25,1)',
  primaryGreyGreen: 'rgba(113,138,66,1)',
  textHighlight: 'rgba(68,143,255,1)',
  text00: 'rgba(20,26,30,1)',
  text10: 'rgba(46,54,59,1)',
  text20: 'rgba(72,81,88,1)',
  text30: 'rgba(98,109,116,1)',
  text40: 'rgba(123,136,145,1)',
  text50: 'rgba(149,164,173,1)',
  text60: 'rgba(175,191,202,1)',
  text70: 'rgba(202,213,220,1)',
  text80: 'rgba(229,234,238,1)',
  text90: 'rgba(255,255,255,1)',
  text100: 'rgba(255,255,255,1)',
  buy10: 'rgba(33,112,67,0.300)',
  buy20: 'rgba(94,148,124,1)',
  buy30: 'rgba(72,196,142,1)',
  buy40: 'rgba(39,172,114,1)',
  buy50: 'rgba(14, 203, 129, 1)',
  buy60: 'rgba(14, 203, 129, 0.9)',
  buy70: 'rgba(33, 112, 67, 0.3)',
  sell10: 'rgba(144,43,43,0.300)',
  sell20: 'rgba(221,94,86,0.400)',
  sell30: 'rgba(221,94,86,1)',
  sell40: 'rgba(207,59,49,1)',
  sell50: 'rgba(245, 69, 93, 1)',
  sell60: 'rgba(245, 69, 93, 0.9)',
  sell70: 'rgba(221, 94, 86, 0.4)',
  notificationBlue01: 'rgba(55,72,84,0.800)',
  notificationBlue02: 'rgba(0,108,229,1)',
  notificationGreen01: 'rgba(55,70,55,0.800)',
  notificationGreen02: 'rgba(65,158,106,1)',
  notificationRed01: 'rgba(70,55,55,0.800)',
  notificationRed02: 'rgba(216,50,50,1)',
  notificationYellow01: 'rgba(91,81,60,0.800)',
  notificationYellow02: 'rgba(238,149,0,1)',
  notificationPurple01: 'rgba(55, 59, 70, 0.8)',
  notificationPurple02: 'rgba(121, 113, 211, 1)',

  borderLayout: 'rgba(46,54,59,1)',

  bgMask: 'rgba(5, 7, 20, 0.6)',
  bgHistoryTabs: 'rgba(35,37,45,1)',
  bgNavButton: 'rgba(51,55,67,1)',
  networkSelectionBgColor: 'rgba(20,21,26,1)',
  withdrawTypeBgColor: 'rgba(142,205,30,1)',
  TabHoverColor: 'rgba(160,238,9,1)',
  balanceGroupBorderColor: 'rgba(160,238,9,1)',
  balanceGroupHoverBgColor: 'rgba(160,238,9,1)',
  balanceGroupHoverBorderColor: 'rgba(160,238,9,1)',

  DatePickerInput: 'rgba(255, 255, 255, 0.23)',
  BoxBg01: 'rgba(23,26,30,1)',
  BoxBg02: 'rgba(46, 54, 59, 1)',
  BoxBg03: 'rgba(46, 54, 59, 1)',
  BoxBg04: 'rgba(160, 238, 9, 1)',
  BoxBorder01: 'rgba(46,54,59,1)',
  BoxLineBg: 'rgba(23,26,30,1)',
  BoxBtnBg: 'rgba(98, 109, 116, 1)',
  BoxBtnBg02: 'rgba(46, 54, 59, 1)',
  BoxBtnColor: 'rgba(160, 238, 9, 1)',
  BoxRankBg01: 'rgba(45, 58, 18, 1)',
  BoxRankBorder01: 'rgba(160, 238, 9, 1)',
  BoxRankBg02: 'rgba(44, 45, 16, 1)',
  BoxRankBorder02: 'rgba(244, 248, 85, 1)',
  BoxRankBg03: 'rgba(17, 52, 44, 1)',
  BoxRankBorder03: 'rgba(9, 238, 183, 1)',
  BoxDialogBg: 'rgba(23, 26, 30, 1)',
  BoxDialogBg02: 'rgba(35, 37, 45, 1)',
  BoxHistoryRow: 'rgba(172, 172, 172, 0.10)',
  bg2: 'rgba(43, 49, 57, 1)',
}
